export function buildRegisterCampaignPayload(formData, campaignKey) {
  return {
    phoneNumber: formData.celular,
    fullName: formData.nombre,
    campaignKey,
    birthDate: formData.fechaNacimiento || undefined,
    hasVoucherExperience: Boolean(formData.experienciaVales),
    difusionChannel: formData.comoTeEnteraste || undefined,
    otherChannel: formData.otherChannel || undefined,
    cityCodeName: formData.cityCodeName || undefined,
  };
}
